import { render } from "./HomeProyectos.vue?vue&type=template&id=120c4467&scoped=true"
import script from "./HomeProyectos.vue?vue&type=script&lang=js"
export * from "./HomeProyectos.vue?vue&type=script&lang=js"

import "./HomeProyectos.vue?vue&type=style&index=0&id=120c4467&scoped=true&lang=css"

import exportComponent from "/home/nodejs/front/monitor/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-120c4467"]])

export default __exports__